/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @emails oncall+relay
 * 
 * @format
 */
'use strict';

var HooksImplementation = require('./HooksImplementation');

var useRefetchableFragmentNode = require('./useRefetchableFragmentNode');

var useStaticFragmentNodeWarning = require('./useStaticFragmentNodeWarning');

var _require = require('react'),
    useDebugValue = _require.useDebugValue;

var _require2 = require('relay-runtime'),
    getFragment = _require2.getFragment;

function useRefetchableFragment_LEGACY(fragmentInput, fragmentRef) {
  var fragmentNode = getFragment(fragmentInput);
  useStaticFragmentNodeWarning(fragmentNode, 'first argument of useRefetchableFragment()');

  var _useRefetchableFragme = useRefetchableFragmentNode(fragmentNode, fragmentRef, 'useRefetchableFragment()'),
      fragmentData = _useRefetchableFragme.fragmentData,
      refetch = _useRefetchableFragme.refetch;

  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useDebugValue({
      fragment: fragmentNode.name,
      data: fragmentData
    });
  }
  /* $FlowExpectedError[prop-missing] : Exposed options is a subset of internal
   * options */


  return [fragmentData, refetch];
}

function useRefetchableFragment(fragmentInput, parentFragmentRef) {
  var impl = HooksImplementation.get();

  if (impl) {
    return impl.useRefetchableFragment(fragmentInput, parentFragmentRef);
  } else {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useRefetchableFragment_LEGACY(fragmentInput, parentFragmentRef);
  }
}

module.exports = useRefetchableFragment;